module.exports = __webpack_public_path__ + "img/share3.22079a37.jpg";